<template>
  <div class="locations">
    <v-container class="my-5">
      <v-row justify="center">
        <v-col>
          locations
          <!-- <LocationsTable :propSearch="search" :propHeaders="locationsHeaders" /> -->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import LocationsTable from '@/components/LocationsTable'

export default {
  name: 'Locations',

  components: {
    // LocationsTable
  },

  data: () => ({
    search: '',
    locationsHeaders: [
      { text: 'Serial Number', value: 'serialNumber' },
      { text: 'Casing IDs', value: 'casingIds' },
      { text: 'FW', value: 'installedFwVersion' },
      { text: 'Created', value: 'createdAt' },
      { text: 'Updated', value: 'updatedAt' }
    ]
  })
}
</script>
